import { useTheme } from '@mui/material';
import CustomZeroKnowledgeProofDevelopmentIcon from '../../../public/svg/icons/zkdServices/CustomZeroKnowledgeProofDevelopment.svg';
import FullStackZKIntegrationIcon from '../../../public/svg/icons/zkdServices/FullStackZKIntegration.svg';
import PrivacyPreservingSmartContractsIcon from '../../../public/svg/icons/zkdServices/PrivacyPreservingSmartContracts.svg';
import ZKRollupScalingSolutionsIcon from '../../../public/svg/icons/zkdServices/ZKRollupScalingSolutions.svg';

export const ZeroKnowledgeProofDevelopmentServicesData = {
  mainText: 'Zero-Knowledge Proof Development with Rumble Fish',
  description: `We build zero-knowledge proof systems that let you verify information without revealing it, enabling private transactions, scalable blockchain solutions, and regulatory compliance without compromising on security. Our team specializes in custom ZK circuit development, rollup implementations, and privacy-preserving smart contracts that work in production environments. Whether you need confidential DeFi protocols, private voting systems, or enterprise blockchain applications, we architect solutions tailored to your specific requirements.`,
};

export const AccordionData = () => {
  const theme = useTheme();
  return [
    {
      iconSvg: CustomZeroKnowledgeProofDevelopmentIcon,
      iconSvgAlt: 'custom-zero-knowledge-proof-development',
      title: 'Custom Zero-Knowledge Proof Development',
      description:
        "We don't just implement existing protocols; we architect ZK solutions that fit your specific needs. Whether you're building privacy-preserving DeFi protocols, confidential voting systems, or enterprise blockchain applications, we've got you covered.<br /><b>Our ZK Expertise:</b><br />" +
        `<ul>` +
        `<li><b>SNARKs & STARKs:</b> Deep experience with both approaches. And anything in between.</li>` +
        `<li><b>zkEVM Development:</b> Ethereum-compatible zero-knowledge solutions</li>` +
        `<li><b>ZK Rollup Implementation:</b> Layer 2 scaling solutions that actually scale</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.tealGradient?.background as string,
    },
    {
      iconSvg: ZKRollupScalingSolutionsIcon,
      iconSvgAlt: 'zk-rollup-scaling-solutions',
      title: 'ZK Rollup & Scaling Solutions',
      description:
        'Tired of Ethereum gas fees eating your profits? Our ZK rollup solutions process transactions off-chain while maintaining security guarantees. Think zkSync Era, but custom-built for your use case.' +
        `<ul>` +
        `<li><b>150-300ms confirmation times</b> (yes, really)</li>` +
        `<li><b>99%+ cost reduction</b> compared to mainnet</li>` +
        `<li><b>EVM compatibility</b> - your existing contracts work out of the box</li>` +
        `<li><b>Bulletproof security</b> with zero-knowledge validity proofs</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.tealGradient?.background as string,
    },
    {
      iconSvg: PrivacyPreservingSmartContractsIcon,
      iconSvgAlt: 'privacy-preserving-smart-contracts',
      title: 'Privacy-Preserving Smart Contracts',
      description:
        'Build smart contracts that execute without revealing sensitive data. Perfect for:' +
        `<ul>` +
        `<li><b>Confidential DeFi:</b> Trading without front-running</li>` +
        `<li><b>Private DAOs:</b> Governance without public vote tracking</li>` +
        `<li><b>Enterprise Solutions:</b> Business logic that stays confidential</li>` +
        `<li><b>Identity Verification:</b> Prove eligibility without exposing personal data</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.tealGradient?.background as string,
    },
    {
      iconSvg: FullStackZKIntegrationIcon,
      iconSvgAlt: 'full-stack-zk-integration',
      title: 'Full-Stack ZK Integration',
      description:
        'We handle the entire pipeline, from cryptographic protocol design to frontend integration:' +
        `<ul>` +
        `<li><b>Backend:</b> Proof generation, verification systems, blockchain integration</li>` +
        `<li><b>Frontend:</b> User-friendly interfaces that hide the complexity</li>` +
        `<li><b>Infrastructure:</b> Scalable proving services and key management</li>` +
        `<li><b>Security:</b> Comprehensive audits and battle-tested implementations</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.tealGradient?.background as string,
    },
  ];
};
